<template>
  <div class="operationBox" :class="{replaceBox_B: bCb_}" ref="operationBox">
    <h4>
      <h3></h3>
      翻译建议
    </h4>

    <!-- <h5 class="termTit" v-show="termHintList_.length > 0">记忆库提示</h5>
    <ul class="hint">
      <li v-for="(item, index) in termHintList_" :key="index">
        <p v-html="item.sourceSent"></p>
        <p>{{ item.targetSent }}</p>
      </li>
    </ul> -->
    <div class="operation">
      <seek v-show="isSeekBox_ === 1" :seekTxt="seekTxt_" :seekTxt2="seekTxt2_" :seekNum="seekNum_"
            :seekNum2="seekNum2_" @onSeekTxt="onSeekTxt" @onSeekTxt2="onSeekTxt2"
            @seekChange="seekChange" @onReplace="onReplace" @replaceChange="replaceChange"
            @previous="previous" @seekNext="seekNext"></seek>
      <!-- @seekChange="seekChange" @onReplace="onReplace" @replaceChange="replaceChange"
        @previous="previous" @seekNext="seekNext" @onSeekTxt="onSeekTxt" @onSeekTxt2="onSeekTxt2" -->
      <div class="find mainBox" v-if="isSeekBox_ === 2">
        <h5>查词</h5>
        <div>
          <input type="text" placeholder="输入名称" @change="search" v-model="seekTxt_" />
          <i class="search el-icon-search"></i>
        </div>
        <h5>释义</h5>
        <!-- <h5 class="bor"></h5> -->
        <ul class="findBox mainBox">
          <li v-show="!placeholder">未查询到释义</li>
          <!-- <template > -->
          <li v-for="(item) in dictItemList" v-show="placeholder" :key="item.sourceWord">
            <span>{{ item.sourceWord }}:&nbsp;</span>
            {{ item.targetWord }}
          </li>
          <!-- </template> -->
        </ul>
      </div>
      <div class="addTerm mainBox" v-show="isSeekBox_ === 3">
        <h5>添加术语</h5>
        <input class="sourceInput" placeholder="输入要添加的术语" type="text" v-model="inputTxt_" />
        <div class="addBox">
          <input class="targetInput" placeholder="输入要添加的译文" type="text" v-model="targetInput_" />
          <button @click="addTermSent">添加</button>
        </div>
      </div>
      <div class="addPostil mainBox" v-show="isSeekBox_ === 4">
        <h5>添加批注</h5>
        <textarea rows="10" cols="40" autofocus maxlength="50" placeholder="请输入批注内容"
                  v-model="postilTxt"></textarea>
        <button @click="addInsert">确定</button>
      </div>
      <div class="postilList mainBox" v-show="isSeekBox_ === 5">
        <template v-for="(item,index) in getFragmentRemarkInfo">
          <div :key="index">
            <h5>批注
              <span>
                <i class="update_icon" v-if="ifSubmit_" @click="onDisabled(item)"></i>
                <i class="confirm_icon" v-if="ifSubmit_" @click="updateInsert(item)"></i>
                <i class=" del_icon" v-if="ifSubmit_" @click="delPosti(item)"></i>
              </span>
            </h5>
            <!-- updatePostilTxt_ -->
            <textarea rows="10" cols="40" maxlength="50" :disabled="item.disabled" autofocus
                      placeholder="请输入批注内容" v-model="item.comment"></textarea>
          </div>
        </template>

        <!-- <button @click="updateInsert" v-if="ifSubmit_">保存</button> -->
      </div>
      <div class="QABox mainBox" v-if="isSeekBox_ === 6">
        <h5>QA（质量检查） <button @click="DownloadQAData">导出</button></h5>
        <el-table :data="QAtableData" v-loading="tabLoading" border style="width: 100%"
                  @row-click="rowClick">
          <el-table-column prop="sort" label="句段序号" width="80">
          </el-table-column>
          <el-table-column prop="errorDesc" label="疑似错误" width="">
          </el-table-column>
        </el-table>
      </div>
      <div class="mainBox" v-show="termHintList_.length > 0">
        <h5 class="termTit">术语提示</h5>
        <ul class="hint">
          <li v-for="(item, index) in termHintList_" :key="index">
            <p v-html="item.sourceSent"></p>
            <p>{{ item.targetSent }}</p>
          </li>
        </ul>
      </div>
      <div class="mainBox" v-show="memoryHintList_.length > 0">
        <h5 class="termTit">记忆库提示 </h5>
        <ul class="hint" id="memoryHint">
          <li v-for="(item, index) in memoryHintList_" :key="index">
            <p v-html="item.sourceSent"></p>
            <p>{{ item.targetSent }}</p>
          </li>
        </ul>
        <el-button @click="handleReplace" v-show="isLangMno && row.contentEditable!==0"
                   style="line-height:0;margin-top:10px">替换</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import seek from './seek';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "editorOperation",
  props: ["termHintList", "memoryHintList", "isSeekBox", "seekTxt", "seekNum", "seekNum2", "seekTxt2", "inputTxt", "targetInput", "queryData", "bCb", "postilTarget", "updatePostilTxt", "postilId", "ifSubmit", "row"],
  data () {
    return {
      placeholder: true,
      dictItemList: [],
      disabled: true,
      queryData_: this.queryData,
      postilTxt: "",
      contentEditable: '',
      // inputTxt_:this.inputTxt_com
      QAtableData: [],
      QAData: {},
      tabLoading: true,
      QATitleAry: [
        { label: '项目名称', prop: 'projectName' },
        { label: '文件名', prop: 'fileName' },
        { label: '语言对', prop: 'langDesc' },
        { label: '负责人', prop: 'transUserName' },
        { label: '句段序号', prop: 'sort' },
        { label: '原文', prop: 'sourceSent' },
        { label: '译文', prop: 'targetSent' },
        { label: '疑似错误', prop: 'errorDesc' }
      ],
      QACode: "",
      QAInterval: null,
      memoryHintList_: [],
      termHintList_: [],
    };
  },
  watch: {
    memoryHintList: {
      handler (newVal) {
        this.memoryHintList_ = [...newVal]
      },
      deep: true
    },
    termHintList: {
      handler (newVal) {
        this.termHintList_ = [...newVal]
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters('editor', [
      'getFragmentRemarkInfo'
    ]),

    isLangMno () {
      const { sourceLang, targetLang } = this.queryData_
      if ([sourceLang, targetLang].includes('mno')) {
        return true
      }
      return false
    },

    // termHintList_ () {
    //   return this.termHintList
    // },
    // memoryHintList_ () {
    //   return this.memoryHintList
    // },
    ifSubmit_ () {
      return this.ifSubmit
    },
    isSeekBox_ () {
      if (this.isSeekBox == 6) {
        this.tabLoading = true;
        this.QAtableData = [];
        this.getQAKey();
      } else if (this.isSeekBox === 4) {
        this.postilTxt = ''
      }
      return this.isSeekBox
    },
    seekTxt_: {
      get () {
        return this.seekTxt;
      },
      set (val) {
        this.$emit("onSeekTxt", val);
      }
    },
    seekNum_ () {
      return this.seekNum
    },
    seekNum2_ () {
      return this.seekNum2
    },
    seekTxt2_: {
      get () {
        return this.seekTxt2;
      },
      set (val) {
        this.$emit("onSeekTxt2", val);
      }
    },
    inputTxt_: {
      get (val) {
        return this.inputTxt;
      },
      set (val) {
        this.$emit("onInputTxt", val);
      }
    },
    targetInput_: {
      get (val) {
        return this.targetInput;
      },
      set (val) {
        this.$emit("onTargetInput", val);
      }
    },
    bCb_ () {
      return this.bCb
    },
    postilTarget_ () {
      return this.postilTarget
    },
    postilId_ () {
      return this.postilId
    },
    updatePostilTxt_: {
      get (val) {
        return this.updatePostilTxt;
      },
      set (val) {
        this.$emit("onUpdatePostilTxt", val);
      }
    }
  },
  components: {
    seek
  },
  async created () {
    this.mm = 0
  },
  beforeDestroy () {
    clearInterval(this.QAInterval);
  },
  methods: {
    ...mapActions('editor', [
      'setFragmentInfo',
      'getCurrentRemarksInfo'
    ]),
    handleReplace () {
      // console.log(this.memoryHintList);
      this.$emit('handleReplace', this.memoryHintList)
    },
    onDisabled (item) {
      if (this.ifSubmit_) {
        item.disabled = false
      }
    },
    rowClick (row) {
      this.$emit("goQA", row)
    },
    onSeekTxt2 (val) {
      this.seekTxt2_ = val
    },
    onSeekTxt (val) {
      this.seekTxt_ = val
    },
    // 获取QA列表
    async getQATab () {
      const { result, success } = await this.catReq1Service("/api/v1/file/getQAResult", { taskKey: this.QACode }, 'get')
      if (!success) {
        clearInterval(this.QAInterval);
        this.tabLoading = false;
        return
      }
      if (result.percent == 100) {
        this.tabLoading = false;
        this.QAtableData = result.detailList;
        this.QAData = {
          fileName: result.fileName,
          langDesc: result.langDesc,
          projectName: result.projectName
        };
        clearInterval(this.QAInterval);
      }
    },
    // 获取QA key
    async getQAKey () {
      const params = {
        fileId: this.queryData_.fileId,
        marker: this.queryData_.transStatus,
        taskId: this.queryData_.taskId
      };
      const response = await this.catReq1Service("/api/v1/file/checkQA", params, 'get')
      if (!response.success) {
        this.tabLoading = false;
        return
      }
      clearInterval(this.QAInterval);
      this.QACode = response.result;
      this.QAInterval = window.setInterval(this.getQATab, 2000);
    },
    // 导出的方法
    async DownloadQAData () { // 导出表格的表头设置
      let columnNames = [];
      let columnValues = [];
      let list, tHeader, filterVal, fileName;
      fileName = "QA列表-" + this.QAData.fileName;
      list = this.QAtableData;
      console.log("导出")
      list.forEach((item) => {
        item.fileName = this.QAData.fileName;
        item.langDesc = this.QAData.langDesc;
        item.projectName = this.QAData.projectName;
      })
      if (list.length < 1) {
        return
      }
      let allColumns = this.QATitleAry;
      for (let i = 0; i < allColumns.length; i++) {
        columnNames[i] = allColumns[i].label
        columnValues[i] = allColumns[i].prop
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require('vendor/Export2Excel')
        tHeader = columnNames
        filterVal = columnValues
        let data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, fileName)
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 查词搜索
    search (e) {
      let that = this;
      let seekTxt_ = this.seekTxt_.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      let params = {
        showTarget: 1,
        sourceWord: seekTxt_,
        fileId: this.queryData.fileId,
        sourceLang: that.queryData_.sourceLang,
        targetLang: that.queryData_.targetLang
      };
      if (seekTxt_ === "") {
        that.dictItemList = "";
        return;
      }
      this.catReq1Service(
        "/api/v1/dict/queryDictItemList",
        params,
        "post",
        2
      ).then(function (response) {
        if (response.resultCode === "0") {
          return;
        }
        if (response.result.length < 1) {
          that.placeholder = false;
        } else {
          that.placeholder = true;
        }
        that.dictItemList = response.result;
      });
    },
    // 修改批注
    async updateInsert (item) {
      let { comment, disabled, id, sentId } = item
      comment = comment.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      if (comment === "") {
        this.$message.closeAll();
        this.$message({
          message: "批注文不能为空",
          type: "warning"
        });
        return
      }
      const { txt } = this.postilTarget_
      const { fileId } = this.queryData_
      const params = {
        commentIndex: txt.length,
        comment,
        commentType: 3,
        sentId,
        transFileId: fileId,
        commentSent: txt,
        sourceSent: txt,
        id
      }
      const { success } = await this.catReq1Service("/api/v1/comment/update", params);
      if (!success) {
        return
      }
      this.$message.closeAll();
      this.$message({ message: "修改批注成功", type: "success" });
      disabled = true;
      const remarkParams = {
        transFileId: fileId,
        sentIdList: [sentId]
      }
      this.getCurrentRemarksInfo(remarkParams)
      // this.$emit("updateTableRow", row);
      // this.$emit('setPostilId', this.postilTarget_.tag, row)

    },
    // 新增批注
    async addInsert () {
      this.postilTxt = this.postilTxt.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      if (this.postilTxt === "") {
        this.$message.closeAll();
        this.$message({
          message: "批注内容不能为空",
          type: "warning"
        });
        return
      }
      const { txt, sid, tag } = this.postilTarget_
      const { fileId, sourceLang, targetLang } = this.queryData_
      const params = {
        commentIndex: txt.length,
        comment: this.postilTxt, //文本域输入内容
        commentType: 3,
        sentId: sid,
        transFileId: fileId,
        commentSent: txt,
        sourceSent: txt,
        modeType: 1
      }
      // const res = await this.catReq1Service("/api/v1/comment/insert", params);
      const { success, result } = await this.setFragmentInfo(params)
      this.postilTxt = ""
      if (!success) {
        return
      }
      this.$message.closeAll();
      this.$message({
        message: "新增批注成功",
        type: "success"
      });
      this.$emit("setIsSeekBox", '0')
      this.$emit('setPostilId', tag, result)
      if ([sourceLang, targetLang].includes('mno')) {
        // 蒙古语更新当前句字批注状态
        this.$emit("updateTableRow", result)
      }
      // this.$emit('setPostilId', this.postilTarget_.tag, result)
    },
    // 删除批注
    async delPosti (item) {
      const { id, sentId } = item
      const { fileId } = this.queryData_
      const { sid, tag, butTag, txt } = this.postilTarget_
      const params = {
        commentIdList: [id],
        transFileId: fileId
      }
      const { success } = await this.catReq1Service("/api/v1/comment/deleteBatch", params);
      if (success) {
        this.$message.closeAll();
        this.$message({
          message: "删除批注成功",
          type: "success"
        });
        const remarkParams = {
          transFileId: fileId,
          sentIdList: [sentId]
        }
        await this.getCurrentRemarksInfo(remarkParams)
        if (this.getFragmentRemarkInfo && this.getFragmentRemarkInfo.length === 0 && tag) {
          let parentNode = this.postilTarget_.tag.parentNode;
          tag.setAttribute("pid", '')
          parentNode.removeChild(butTag);
        } else {
          const row = {
            commentType: 1,
            commentSent: txt,
            comment: '',
            sentId,
            id,
          }
          this.$emit("updateTableRow", row)
        }
      }
    },
    seekChange () {
      this.$emit('seekChange')
    },
    onReplace () {
      this.$emit('onReplace')
    },
    replaceChange () {
      this.$emit('replaceChange')
    },
    previous () {
      this.$emit('previous')
    },
    seekNext () {
      this.$emit('seekNext')
    },
    addTermSent () {
      this.$emit("addTerm")
    }
  },
};
</script>
<style lang="less" scoped>
.backColorB {
  .operationBox {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;
    h3 {
      background: #507383 !important;
    }
    h4 {
      color: #c6c6c6;
    }
    h5 {
      color: #c6c6c6;
    }
    .mainBox {
      color: rgba(198, 198, 198, 1) !important;
      h5 {
        color: rgba(198, 198, 198, 1) !important;
      }
      textarea {
        background: #507383 !important;
        color: white !important;
      }
      textarea::-webkit-input-placeholder {
        color: white !important;
      }
    }
    .find {
      div {
        input {
          background: #507383 !important;
          border: none !important;
          color: white !important;
        }
        input::-webkit-input-placeholder {
          color: white !important;
        }
      }
      .findBox {
        border: 1px solid #507383 !important;
        li {
          color: white !important;
        }
      }
    }
    .addTerm {
      input {
        background: #507383 !important;
        border: none !important;
        color: white !important;
      }
      input::-webkit-input-placeholder {
        color: white !important;
      }
    }
    button {
      background: #507383 !important;
      color: white !important;
      border: none !important;
    }
    button:hover {
      background: #405964 !important;
    }
    button:active {
      background: #2c4753 !important;
    }
  }
}
.operationBox {
  float: right;
  width: 100%;
  height: 100%;
  margin-right: 1%;
  overflow: auto;
  background: rgba(255, 255, 255, 1);
  padding: 5px 0;
  box-sizing: border-box;
  .termTit {
    margin-left: 20px;
    width: 80%;
  }
  .operation {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .addTerm {
      .sourceInput {
        width: 280px;
        height: 38px;
        line-height: 28px;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        padding: 0 10px;
        margin-bottom: 10px;
        width: 100%;
        box-sizing: border-box;
      }
      .sourceInput:focus {
        outline: none;
        border: 1px solid #454545;
      }
      .addBox {
        // display: flex;
        // align-items: center;
        // justify-content: space-around;
        box-sizing: border-box;
        width: 100%;
        .targetInput {
          width: 130px;
          height: 38px;
          background: rgba(241, 245, 255, 1);
          border: 1px solid rgba(187, 187, 187, 1);
          border-radius: 4px;
          padding: 0 10px;
          float: left;
        }
        .targetInput:focus {
          outline: none;
          border: 1px solid #454545;
        }
        button {
          width: 90px;
          height: 38px;
          float: right;
        }
      }
    }
    .addPostil {
      width: 260px;
      height: 180px;
      border-radius: 4px;
      h5 {
        margin: 10px;
      }
      button {
        width: 70px;
        height: 30px;
        float: right;
        margin-right: 10px;
        margin-top: 10px;
      }
    }
    .postilList {
      h5 {
        width: auto !important;
        span {
          float: right;
        }
        i {
          display: inline-block;
          height: 20px;
          width: 20px;
          margin: 0 5px;
          cursor: pointer;
        }
        .update_icon {
          background: url("~@/assets/imgs/editor/normal_edits.icon.png")
            no-repeat;
        }
        .confirm_icon {
          background: url("~@/assets/imgs/editor/confirm.png") no-repeat;
          background-size: 22px 24px;
          background-position-y: -2px;
        }
        .del_icon {
          background: url("~@/assets/imgs/editor/normal_deletess.icon.png")
            no-repeat;
        }
      }
      button {
        width: 70px;
        float: right;
        margin-right: 10px;
        margin-top: 10px;
      }
    }
    .mainBox {
      border-radius: 4px;
      width: 260px;
      margin-top: 10px;
      box-sizing: border-box;
      padding: 10px;
      input:focus {
        outline: none;
        border: 1px solid #454545;
      }
      textarea:focus {
        outline: none;
        border: 1px solid #454545;
      }
      input {
        box-sizing: border-box;
      }
      button {
        background: #e8efff;
        border: 1px solid #388de4;
        border-radius: 4px;
        height: 38px;
        line-height: 38px;
        font-size: 12px;
        color: rgba(56, 141, 228, 1);
        box-sizing: border-box;
      }
      button:active {
        background: rgba(51, 144, 255, 1);
        border-radius: 4px;
        color: white;
        border: 1px solid #378de3;
      }
      textarea {
        width: 240px;
        height: 90px;
        resize: none;
        box-sizing: border-box;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        padding: 5px;
      }
      h5 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(34, 34, 34, 1);
        margin: 10px 0px 10px 10px;
        width: 100%;
        text-align: left;
      }
    }
    .QABox {
      /deep/.el-table {
        td:nth-child(1) {
          text-align: center;
        }
        th,
        td {
          padding: 5px 0;
        }
        th {
          background: rgba(226, 231, 243, 1);
        }
        td {
          border: 0px;
          border-bottom: 1px solid #ebeef5;
          cursor: pointer;
        }
        th:nth-child(1) {
          text-align: center;
        }
      }
      h5 {
        width: auto;
        height: 30px;
        line-height: 30px;
      }
      button {
        width: 70px;
        height: 30px;
        line-height: 30px;
        float: right;
      }
    }
    .find {
      width: 260px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: relative;
      div {
        position: relative;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        input {
          //  float: right;
          width: 100%;
          height: 38px;
          line-height: 36px;
          border: 1px solid rgba(187, 187, 187, 1);
          border-radius: 4px;
          padding: 0 10px;
          padding-right: 26px;
        }
        .search {
          position: absolute;
          right: 3%;
          top: 10px;
          cursor: pointer;
        }
      }
      .findBox {
        min-height: 50px;
        max-height: 180px;
        width: 100%;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        text-align: left;
        padding: 10px;
        overflow: auto;
        li {
          padding: 3px 0;
          span {
            font-weight: 700;
          }
        }
      }
    }
  }
  .hint {
    overflow: auto;
    // border: #cdeb9c 1px solid;
    li {
      // float: left;
      text-align: left;
      margin: 0 10px;
      p {
        word-wrap: break-word;
        word-break: normal;
      }
    }
  }
  h4 {
    text-align: left;
    margin-top: 15px;
    margin-left: 20px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    h3 {
      // border-left: 5px solid #166DC3;
      width: 4px;
      height: 18px;
      background: rgba(51, 144, 255, 1);
      float: left;
      margin-right: 15px;
      position: relative;
      top: 4px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
    }
  }
}
</style>
